import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { CardHeader, CardFooter, Row, Button, Col, Label, Input } from 'reactstrap'
import { useSelector } from 'react-redux'
import { RootState } from 'index'
import { fieldObjectInterface } from './FirstReport/FirstReportForm'
import FormValuesDebug from 'utils/debugTools/FormValuesDebug'
import apiGlobal from 'global/api.global'
import { queryKeyes } from 'shared/queryKeys'
import { errorToast, successToast } from 'Components/Toasts'
import { useQuery } from 'react-query'
import { Get } from 'VesselMaster/vesselMaster.hooks'
import { queryClient } from 'react-query/queryClient'
import ErrorComponent from 'Components/ErrorComponent'
import { useDocumentTitle } from 'Components/useDocument.hooks'
import * as Yup from "yup";
import { errResponse, handleServerResponse, isConfigurationButtonDisabled } from 'GenericForms/Helper'
import { VesselConfigrationTabs } from 'shared/constants'
import DeletePopOver from 'Components/DeletePopOver'
import env from 'environment_system/env_system'
import ErrorTooltip from 'Components/ErrorTooltip'
import isEqual from "fast-deep-equal";
import { commonValidationMessages } from 'Components/ValidationErrorMessages'
import FormLoading from 'Components/FormLoading'

interface LNGTankFormItem {
    id?: number;
    name_of_tanks: string;
    no_of_tanks: number | string;
    vessel?: number;
    voyage_information?: number | null;
    vessel_reporting_information?: number | null;
}interface CargoTankDetailsType {
    voyageId?: number,
    reportId?: number,
    activeTab?: number
    setCheckValuesBeforeSwitch: (value: boolean) => void;
    setTabName: (value: string) => void;
    setFormik: (value: any) => void;
    VesselConfActiveTab: number;
    refreshForm: boolean;
}

const CargoTankDetails = ({
    voyageId,
    reportId,
    activeTab,
    setCheckValuesBeforeSwitch,
    setTabName,
    setFormik,
    VesselConfActiveTab,
    refreshForm,
}: CargoTankDetailsType) => {
    /** State variables */
    useDocumentTitle('Cargo Tank Details - ecoSAIL');
    const { VesselID, Vessels } = useSelector((state: RootState) => state.Reporting);
    const [refreshKey, setRefreshKey] = useState<number>(0)
    const [deletepopover, setDeletePopover] = useState<boolean>(false);
    const [index, setIndex] = useState<number>(0);
    let vessel = Vessels.find((rec: any) => rec.id === VesselID) ?? null;
    /** Load LNG Tank object by vessel ID*/
    const {
        data: LNGTankObject,
        isLoading: LNGTankLoading,
        isError: LNGTankError
    }: { data: any; isLoading: any; isError: any } = useQuery(
        [queryKeyes.vessel.LNGTankByVessel.key, VesselID],
        async () => {
            return await Get(queryKeyes.vessel.LNGTankByVessel.url(VesselID), VesselID);
        },
        { staleTime: Infinity }
    );
    const fieldArray: fieldObjectInterface[] = [
        {
            label: "Name of tank",
            field: "name_of_tanks",
            input: "text"
        },
        {
            label: "Tank number",
            field: "no_of_tanks",
            input: "text"
        },
    ]

    /** Assign initial values to formik object */
    const getInitialValues = () => {
        if (LNGTankObject &&
            Array.isArray(LNGTankObject) &&
            LNGTankObject.length > 0) {
            return LNGTankObject;
        } else {
            let arr: { [key: string]: string | number | boolean | null }[] = [];
            let obj: { [key: string]: string | number | boolean | null } = {};
            fieldArray.forEach((fieldObj: fieldObjectInterface) => {
                obj[fieldObj?.field] = fieldObj?.value ?? null;
                obj.vessel = VesselID;
            })
            arr.push(obj);
            return arr;
        }
    }

    const LNGTankValidationSchema = Yup.object().shape({
        LNGTank: Yup.array()
            .of(
                Yup.object().shape({
                    no_of_tanks: Yup.number().typeError(commonValidationMessages.number)
                        .required(commonValidationMessages.required),
                    name_of_tanks: Yup.string()
                        .required(commonValidationMessages.required)
                })
            )
            .test(
                "unique-no_of_tanks",
                "Tank numbers must be unique",
                function (value) {
                    if (!value) return true;
                    const seen = new Set();
                    for (let i = 0; i < value.length; i++) {
                        const tankNo = value[i]?.no_of_tanks;
                        if (tankNo != null) {
                            if (seen.has(tankNo)) {
                                return this.createError({
                                    path: `LNGTank[${i}].no_of_tanks`,
                                    message: "Duplicate tank number",
                                });
                            }
                            seen.add(tankNo);
                        }
                    }
                    return true;
                }
            )
            .test(
                "unique-name_of_tanks",
                "Tank names must be unique",
                function (value) {
                    if (!value) return true;
                    const seen = new Set();
                    for (let i = 0; i < value.length; i++) {
                        const name = value[i]?.name_of_tanks?.trim()?.toLowerCase();
                        if (name) {
                            if (seen.has(name)) {
                                return this.createError({
                                    path: `LNGTank[${i}].name_of_tanks`,
                                    message: "Duplicate tank name",
                                });
                            }
                            seen.add(name);
                        }
                    }
                    return true;
                }
            ),
    });

    const CargoTankDetailsFormik: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            LNGTank: getInitialValues(),
        },
        validationSchema: LNGTankValidationSchema,
        onSubmit: async (values: any, actions: any) => {
            actions.setSubmitting(true);
            const responseArray: any = [];
            Array.isArray(values.LNGTank) &&
                values.LNGTank.forEach((value: any) => {
                    if (value.no_of_tanks !== undefined && value.name_of_tanks !== undefined) {

                        if (value.id){
                            responseArray.push(apiGlobal.put(`${queryKeyes.vessel.LngTankDetail.url()}${value?.id}/`, value))
                        }else{
                            responseArray.push(apiGlobal.post(`${queryKeyes.vessel.LngTankDetail.url()}`, value))
                        }
                    }
                })
            const response = await handleServerResponse(responseArray);
            if (response === true) {
                queryClient.invalidateQueries(queryKeyes.vessel.LNGTankByVessel.key);
            }
            actions.setSubmitting(false);
        },
    });
    const tabName = 'Cargo Tank Details';
    const handleFormikStateChange = (values: any, initialValues: any) => {
        const areValuesEqual = isEqual(values, initialValues);
        setCheckValuesBeforeSwitch(areValuesEqual);
        setTabName(tabName);
        return areValuesEqual;
    };

    useEffect(() => {
        handleFormikStateChange(CargoTankDetailsFormik.values, CargoTankDetailsFormik.initialValues);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [CargoTankDetailsFormik.values, CargoTankDetailsFormik.initialValues]);

    useEffect(() => {
        if (VesselConfActiveTab === VesselConfigrationTabs.CARGO_TANK_DETAILS && CargoTankDetailsFormik.values !== CargoTankDetailsFormik.initialValues) {
            setFormik(CargoTankDetailsFormik);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [VesselConfActiveTab, CargoTankDetailsFormik?.values]);

    const DeleteLNGTankObject = async (id: number) => {
        await apiGlobal.delete(`${queryKeyes.vessel.LngTankDetail.url()}${id}/`).then(async res => {
            if (res.status === 200 || res.status === 204) {
                successToast("Data deleted successfully!");
                await queryClient.invalidateQueries(queryKeyes.vessel.LNGTankByVessel.key);
                await setRefreshKey((refreshKey: number) => refreshKey + 1);
            }
        }).catch(err => {
            if (errResponse.includes(err.response.status)) {
                errorToast("Internal error occured, please contact the admin");
            }
        });
        queryClient.invalidateQueries(queryKeyes.vessel.LNGTankByVessel.key)
    }

    return (
        <React.Fragment>
            <CardHeader className="p-2 border-0">
                <h4 className="mb-0">Cargo Tank Details</h4>
            </CardHeader>
            {LNGTankLoading && <FormLoading />}
            {LNGTankError && <ErrorComponent message='Error loading required data!' />}
            {!LNGTankLoading &&
                <form onSubmit={CargoTankDetailsFormik.handleSubmit} noValidate autoComplete='off' key={`cargo_tank_details_${refreshKey}_${refreshForm}`}>
                    {activeTab === VesselConfigrationTabs.CARGO_TANK_DETAILS &&
                        CargoTankDetailsFormik?.values?.LNGTank.map((item: LNGTankFormItem, index: number) => {
                            return (
                                <Row key={index} className="ele_row1 pe-0 mt-2">
                                    <Col sm={4}>
                                        <Label className='mb-0 asteric' htmlFor={`name_of_tanks_${index}`}>
                                            Tank Name
                                        </Label>
                                        <Input
                                            key={refreshKey}
                                            onFocus={(e) => e.target.select()}
                                            type="text"
                                            name={`LNGTank.${index}.name_of_tanks`}
                                            id={`name_of_tanks_${index}`}
                                            className="form-control"
                                            value={CargoTankDetailsFormik.values.LNGTank[index]?.name_of_tanks || ""} 
                                            onChange={CargoTankDetailsFormik.handleChange}
                                            onBlur={CargoTankDetailsFormik.handleBlur}
                                            disabled={isConfigurationButtonDisabled(vessel)}
                                        />
                                    </Col>
                                    {CargoTankDetailsFormik?.errors?.LNGTank?.[index]?.name_of_tanks &&
                                        CargoTankDetailsFormik.touched.LNGTank?.[index]?.name_of_tanks &&
                                        env.form_validation &&
                                        <ErrorTooltip
                                            target={`name_of_tanks_${index}`}
                                            message={CargoTankDetailsFormik?.errors?.LNGTank?.[index]?.name_of_tanks}
                                            open={CargoTankDetailsFormik?.errors?.LNGTank?.[index]?.name_of_tanks ? true : false}
                                        />
                                    }
                                    <Col sm={4}>
                                        <Label className='mb-0 asteric' htmlFor={`no_of_tanks_${index}`}>
                                            Tank Number
                                        </Label>
                                        <Input
                                            key={refreshKey}
                                            onFocus={(e) => e.target.select()}
                                            type="text"
                                            name={`LNGTank.${index}.no_of_tanks`}
                                            id={`no_of_tanks_${index}`}
                                            className="form-control"
                                            value={CargoTankDetailsFormik.values.LNGTank[index]?.no_of_tanks || ""} 
                                            onChange={CargoTankDetailsFormik.handleChange}
                                            onBlur={CargoTankDetailsFormik.handleBlur}
                                            disabled={isConfigurationButtonDisabled(vessel)}
                                        />
                                        {CargoTankDetailsFormik?.errors?.LNGTank?.[index]?.no_of_tanks &&
                                            CargoTankDetailsFormik.touched.LNGTank?.[index]?.no_of_tanks &&
                                            env.form_validation &&
                                            <ErrorTooltip
                                                target={`no_of_tanks_${index}`}
                                                message={CargoTankDetailsFormik?.errors?.LNGTank?.[index]?.no_of_tanks}
                                                open={CargoTankDetailsFormik?.errors?.LNGTank?.[index]?.no_of_tanks ? true : false}
                                            />
                                        }
                                    </Col>
                                    {CargoTankDetailsFormik.values?.LNGTank?.length > 1 &&
                                        <Col sm={1}>
                                            <button
                                                type="button"
                                                className="btn justify_left mt-3"
                                                id={`delete_lng_${index}`}
                                            >
                                                <i className='dripicons-trash icon_s18'
                                                    onClick={() => {
                                                        setDeletePopover(true);
                                                        setIndex(index);
                                                    }}
                                                />
                                            </button>
                                        </Col>
                                    }
                                </Row>
                            )
                        })
                    }
                    <Row>
                        {
                            (CargoTankDetailsFormik?.values?.LNGTank.length < 10 ?
                                <Col sm={3}>
                                    {/* Define the push_object variable outside JSX */}
                                    <Label
                                        className="link_color_blue mt-2 mb-0 max-width-18 pointer"
                                        onClick={() => {
                                            if (!isConfigurationButtonDisabled(vessel)) {
                                                CargoTankDetailsFormik.setFieldValue('LNGTank', [
                                                    ...CargoTankDetailsFormik.values.LNGTank,
                                                    {
                                                        name_of_tanks: '',
                                                        no_of_tanks: '',
                                                        vessel: VesselID,
                                                        voyage_information: voyageId,
                                                        vessel_reporting_information: reportId
                                                    }
                                                ]);
                                                setRefreshKey(prevKey => prevKey + 1);
                                            }
                                        }}
                                    >
                                        Add another Cargo Tank
                                    </Label>
                                </Col> :
                                <p className='coloured-bg-grey'>You have reached the limit of 10 LNG Tanks</p>
                            )
                        }
                    </Row>
                    {deletepopover === true &&
                        <DeletePopOver
                            target={`delete_lng_${index}`}
                            onClick={async () => {
                                if (CargoTankDetailsFormik?.initialValues?.LNGTank?.[index]?.id && CargoTankDetailsFormik?.initialValues?.LNGTank?.[index]?.id as number > 0) {
                                    await DeleteLNGTankObject(CargoTankDetailsFormik?.initialValues?.LNGTank?.[index]?.id as number);
                                } else {
                                    // If the LNG Tank is not saved yet, just remove it from the form values
                                    CargoTankDetailsFormik.setFieldValue('LNGTank', CargoTankDetailsFormik.values.LNGTank.filter((_: any, i: number) => i !== index));
                                    setRefreshKey(refreshKey + 1); // Increment key to re-render
                                }
                                setDeletePopover(false); // Close popover after deletion
                            }}
                            state={deletepopover}
                            setState={setDeletePopover}
                        />
                    }
                    <CardFooter className="p-2 py-3">
                        <Row>
                            <div className="d-flex flex-wrap gap-5 grp_justify_right">
                                <Button type="submit" color="primary" className='pos-end' disabled={isConfigurationButtonDisabled(vessel) || CargoTankDetailsFormik.isSubmitting}>
                                    {CargoTankDetailsFormik.isSubmitting && <i className="spinner-border spinner-border-sm text-light me-2" />}
                                    Save
                                </Button>
                            </div>
                        </Row>
                    </CardFooter>
                    <div className='mt-4'>
                        <FormValuesDebug values={[CargoTankDetailsFormik?.values, CargoTankDetailsFormik?.errors, CargoTankDetailsFormik.initialValues]} />
                    </div>
                </form>
            }
        </React.Fragment >
    )
}

export default CargoTankDetails